import Vue from 'vue'

/**
 * @author José Luis R.
 * @param id Casualty's id
 * @return {Array}
 */

export default ({ id }, payload) =>
  Vue.$http.put(`sinister/affected/change-affected-verified-data/${id}/`, payload)
    .then(response => response.data)
